module.exports = __webpack_public_path__ + "static/media/moons_cuanto_cuestan-375.809104cb.jpg";